// REACT
import React from "react";

// MATERIAL-UI
import {
  Grid,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  useTheme,
} from "@mui/material";

// COMPONENTS
import CountryOrCryptoFlag from "src/components/common/CountryOrCryptoFlag";
import InfiniteScroll from "react-infinite-scroll-component";
import Preloader from "src/utils/Preloader";

// ASSETS
import { SelectCurrencyStyles } from "../common/styles/SelectCurrency.styles";
import { DropdownListProps, Data } from "../common/types/dropdownTypes";
import { trackEvent } from "src/Amplitude";

const SLICE_LIMIT = 10;

const DropdownList = (props: DropdownListProps) => {
  const classes = SelectCurrencyStyles();
  const [data, setData] = React.useState<Data[]>([]);
  const [hasMore, setHasMore] = React.useState<boolean>(true);

  const theme = useTheme();
  const upNext = () => {
    setTimeout(() => {
      setData((prev) => [...prev, ...props.data.slice(prev.length, prev.length + SLICE_LIMIT)]);
    }, 1000);
  };

  React.useEffect(() => {
    setData(props.data.slice(0, SLICE_LIMIT));
  }, [props.data]);

  React.useEffect(() => {
    if (props.searchTerm && props.searchTerm <= 0) {
      setData(props.data.slice(0, SLICE_LIMIT));
    }
  }, [props.searchTerm]);

  React.useEffect(() => {
    // Handle hasMore which will control whether to render preloader or not.
    if (data.length === props.data.length) {
      setHasMore(false);
    } else if (data.length >= props.data.length) {
      setHasMore(false);
    } else {
      setHasMore(true);
    }
  }, [data]);

  React.useEffect(() => {
    if (props.searchTerm && props.searchTerm <= 0) {
      setData(props.data.slice(0, SLICE_LIMIT));
    }
  }, [props.searchTerm]);

  return (
    <Grid container>
      <Grid item xs>
        <List id="scrollableDiv" className={classes.list}>
          <InfiniteScroll
            dataLength={data.length}
            next={upNext}
            hasMore={hasMore}
            scrollableTarget="scrollableDiv"
            loader={<Preloader />}
            className={classes.infiniteScroll}
            endMessage={
              <p style={{ textAlign: "center" }}>
                <b>No more results.</b>
              </p>
            }>
            {data.map((el, idx) => (
              <Button
                disableRipple
                fullWidth
                key={idx}
                onClick={() =>
                  trackEvent(`Select_Wallets_page_Deposit_Coin`, {
                    Token_Page: el.name,
                  })
                }>
                <ListItem
                  data-code={el.code}
                  data-icon={el?.logoUrl}
                  data-name={el.name}
                  data-value={el.value}
                  data-price={el.price}
                  data-available={el.available}
                  data-memo={el.memo?.toString() || ""}
                  data-depositable={el.depositable?.toString() || ""}
                  data-inactive={el.inactive?.toString() || ""}
                  onClick={(event) => props.onClick(event, el.code)}>
                  <ListItemAvatar>
                    <Avatar style={{ backgroundColor: "transparent" }}>
                      <CountryOrCryptoFlag name={el?.logoUrl || el.code} size={40} />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={<b>{el.code}</b>}
                    secondary={`${el.name.slice(0, el.name.indexOf("("))} (${el.code})`}
                    sx={{
                      textTransform: "capitalize",
                      "& .MuiTypography-root.MuiTypography-body2": {
                        color: theme.palette.text.primary,
                      },
                    }}
                  />
                </ListItem>
              </Button>
            ))}
          </InfiniteScroll>
        </List>
      </Grid>
    </Grid>
  );
};

export default DropdownList;
